export const DateKey: string = "DateKey";
export const CommitteeKey: string = "CommitteeKey";
export const HearingKey: string = "HearingKey";
export const DocKey: string = "DocKey";
export const CheckedResultsListKey: string = "CheckedResults";
